import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <h1>Created by Raviranjan</h1>
    </div>
  )
}
